import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPharmaProducts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/apps/pharma-product", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchPharmaProduct(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/pharma-product/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addPharmaProduct(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post("/apps/pharma-product", { user: userData })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
